import { render, staticRenderFns } from "./TableIcon.vue?vue&type=template&id=9b07f020&scoped=true"
import script from "./TableIcon.vue?vue&type=script&lang=js"
export * from "./TableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b07f020",
  null
  
)

export default component.exports